import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { UpdateProductPartModalContentTemplate } from 'themes/modules/product/pages';
import { UpdateProductPartModalContentViewStore } from 'modules/product/stores';

@setCurrentView(
	(rootStore, componentProps) => new UpdateProductPartModalContentViewStore(rootStore, componentProps),
	'updateProductPartModalContentViewStore'
)
@observer
class UpdateProductPartModalContent extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <UpdateProductPartModalContentTemplate {...this.props} />;
	}
}

export default observer(UpdateProductPartModalContent);



// WEBPACK FOOTER //
// ./src/modules/product/pages/UpdateProductPartModalContent.jsx